export const formatLargeBalance = (balance: number): string => {
  const formatWithSuffix = (value: number, suffix: string): string => {
    const formatted = value.toFixed(1).replace(/\.0$/, '');
    return formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + suffix;
  };

  const addCommas = (str: string): string => {
    return str.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  if (balance < 1000) {
    return addCommas(balance.toString());
  } else if (balance < 1000000) {
    return formatWithSuffix(balance / 1000, 'K');
  } else if (balance < 1000000000) {
    return formatWithSuffix(balance / 1000000, 'M');
  } else if (balance < 1000000000000) {
    return formatWithSuffix(balance / 1000000000, 'B');
  } else {
    return formatWithSuffix(balance / 1000000000000, 'T');
  }
}
